import { Dispatch } from "redux";
import { LoginService } from "../../services/LoginService";
import { donorapi } from "../../ApiNames";
export const fetchDataSuccess=(data:any) =>({
    type: 'FETCH_DATA_SUCCESS',
    payload: data,
});
export const fetchadddata=(dataview:any) =>({
    type: 'FETCH_ADD_DATA_SUCCESS',
    payload: dataview,
});

export const fetchdata = (uid:any,nameId:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {uid:uid,type:nameId, q :1 };
            const apiname = donorapi.Addfeeds;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const addfeed = (uid:any,nameId:any,description:any,feedbacktype:any,id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {uid:uid,type:nameId,description:description,feedbacktype:feedbacktype,id:id};
            const apiname = donorapi.addsfeed;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchadddata(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
